"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doesTilliGetDeliveryFee = doesTilliGetDeliveryFee;
exports.getAlterationTotal = getAlterationTotal;
exports.getAlterationUnitPriceWithLinings = getAlterationUnitPriceWithLinings;
exports.getAmountWithTax = getAmountWithTax;
exports.getAmountWithoutTax = getAmountWithoutTax;
exports.getBrandBaseDeliveryFee = getBrandBaseDeliveryFee;
exports.getBrandPromoCode = getBrandPromoCode;
exports.getBrandPromoCodes = getBrandPromoCodes;
exports.getCancelFee = getCancelFee;
exports.getCancelFeeCommissionWithTax = getCancelFeeCommissionWithTax;
exports.getCancelFeeCommissionWithoutTax = getCancelFeeCommissionWithoutTax;
exports.getChiffreAffaires = getChiffreAffaires;
exports.getChiffreAffairesBrut = getChiffreAffairesBrut;
exports.getClothTotal = getClothTotal;
exports.getClothUpcyclingTotal = getClothUpcyclingTotal;
exports.getCommission = getCommission;
exports.getCommissionBrand = getCommissionBrand;
exports.getCommissionBrandWithTax = getCommissionBrandWithTax;
exports.getCommissionCustomer = getCommissionCustomer;
exports.getCommissionCustomerWithCancelFeeWithTax = getCommissionCustomerWithCancelFeeWithTax;
exports.getDeliveryFeePaidBrand = getDeliveryFeePaidBrand;
exports.getDeliveryFeePaidCustomer = getDeliveryFeePaidCustomer;
exports.getDeliveryFeePaidCustomerAfterTotalDiscounts = getDeliveryFeePaidCustomerAfterTotalDiscounts;
exports.getDeliveryFees = getDeliveryFees;
exports.getDeliveryFeesCouturier = getDeliveryFeesCouturier;
exports.getDeliveryFeesTilli = getDeliveryFeesTilli;
exports.getDeliveryFeesUptrade = getDeliveryFeesUptrade;
exports.getDiscountValueForBrand = getDiscountValueForBrand;
exports.getInitMinOrderAmountFee = getInitMinOrderAmountFee;
exports.getInitTotal = getInitTotal;
exports.getInitTotalBrandClothes = getInitTotalBrandClothes;
exports.getInitTotalClothes = getInitTotalClothes;
exports.getInitTotalPersonalClothes = getInitTotalPersonalClothes;
exports.getMarginGross = getMarginGross;
exports.getMarginNet = getMarginNet;
exports.getMinOrderAmountFee = getMinOrderAmountFee;
exports.getMinTotalCouturier = getMinTotalCouturier;
exports.getTVAFromAmountWithTax = getTVAFromAmountWithTax;
exports.getTVAFromAmountWithoutTax = getTVAFromAmountWithoutTax;
exports.getTax = getTax;
exports.getTaxBrand = getTaxBrand;
exports.getTaxCustomer = getTaxCustomer;
exports.getTaxOnCommission = getTaxOnCommission;
exports.getTaxOnCommissionBrand = getTaxOnCommissionBrand;
exports.getTaxOnCommissionCustomer = getTaxOnCommissionCustomer;
exports.getTaxOpaqueCouturier = getTaxOpaqueCouturier;
exports.getThresholdGuarantee = getThresholdGuarantee;
exports.getTotal = getTotal;
exports.getTotalAfterTotalDiscounts = getTotalAfterTotalDiscounts;
exports.getTotalBaseBrand = getTotalBaseBrand;
exports.getTotalBaseCustomer = getTotalBaseCustomer;
exports.getTotalBaseCustomerAfterTotalDiscounts = getTotalBaseCustomerAfterTotalDiscounts;
exports.getTotalBaseCustomerAfterTotalDiscountsWithoutDiscountVouchers = getTotalBaseCustomerAfterTotalDiscountsWithoutDiscountVouchers;
exports.getTotalBrandClothes = getTotalBrandClothes;
exports.getTotalBrandRevenue = getTotalBrandRevenue;
exports.getTotalCashCollection = getTotalCashCollection;
exports.getTotalClothes = getTotalClothes;
exports.getTotalCommissionCustomerDiscount = getTotalCommissionCustomerDiscount;
exports.getTotalCommissionDiscount = getTotalCommissionDiscount;
exports.getTotalCouturier = getTotalCouturier;
exports.getTotalCouturierBrand = getTotalCouturierBrand;
exports.getTotalCouturierCustomer = getTotalCouturierCustomer;
exports.getTotalCouturierCustomerDiscount = getTotalCouturierCustomerDiscount;
exports.getTotalCouturierCustomerWithCancelFeeWithTax = getTotalCouturierCustomerWithCancelFeeWithTax;
exports.getTotalCouturierDiscount = getTotalCouturierDiscount;
exports.getTotalCouturierLostOnCommissionDiscount = getTotalCouturierLostOnCommissionDiscount;
exports.getTotalCouturierMobilization = getTotalCouturierMobilization;
exports.getTotalCouturierTilli = getTotalCouturierTilli;
exports.getTotalCouturierTilliAndCustomer = getTotalCouturierTilliAndCustomer;
exports.getTotalCouturierTilliForMinTotalCouturier = getTotalCouturierTilliForMinTotalCouturier;
exports.getTotalCouturierTilliForRepairBonus = getTotalCouturierTilliForRepairBonus;
exports.getTotalCouturierTilliOther = getTotalCouturierTilliOther;
exports.getTotalDiscount = getTotalDiscount;
exports.getTotalDiscountDiscountVouchers = getTotalDiscountDiscountVouchers;
exports.getTotalDiscountPromoCode = getTotalDiscountPromoCode;
exports.getTotalForCustomer = getTotalForCustomer;
exports.getTotalGuarantee = getTotalGuarantee;
exports.getTotalGuaranteeArtisan = getTotalGuaranteeArtisan;
exports.getTotalGuaranteeTilli = getTotalGuaranteeTilli;
exports.getTotalPaid = getTotalPaid;
exports.getTotalPaidBrand = getTotalPaidBrand;
exports.getTotalPaidBrandWithTax = getTotalPaidBrandWithTax;
exports.getTotalPaidWithoutDiscountVouchers = getTotalPaidWithoutDiscountVouchers;
exports.getTotalPartnerProducts = getTotalPartnerProducts;
exports.getTotalPersonalClothes = getTotalPersonalClothes;
exports.getTotalRetailProducts = getTotalRetailProducts;
exports.getTotalWithGuarantee = getTotalWithGuarantee;
exports.getTotalWithTax = getTotalWithTax;
exports.getTotalWithoutTax = getTotalWithoutTax;
exports.getUnitCancelFeeCommissionWithTax = getUnitCancelFeeCommissionWithTax;
exports.getUnitCancelFeeCommissionWithoutTax = getUnitCancelFeeCommissionWithoutTax;
exports.getVolumeAffaires = getVolumeAffaires;
Object.defineProperty(exports, "round", {
  enumerable: true,
  get: function get() {
    return _orderPriceUtils.round;
  }
});
var _config = _interopRequireDefault(require("../config"));
var _deliveryFeeUptrade = _interopRequireDefault(require("./deliveryFeeUptrade"));
var _orderPriceUtils = require("./orderPriceUtils");
var _orderPricePackage = require("./orderPricePackage");
var _orderPrice = require("./orderPrice.discountConcernsOnly");
var _orderPrice2 = require("./orderPrice.discountMaxOnClothSlug");
var _tvaRatios = require("./tvaRatios");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // @ts-check
var defaultDeliveryFee = _config["default"].defaultDeliveryFee,
  defaultMinOrderAmount = _config["default"].defaultMinOrderAmount,
  defaultMinTotalCouturier = _config["default"].defaultMinTotalCouturier,
  defaultCommissionRatio = _config["default"].commissionRatio,
  cancelFee = _config["default"].cancelFee,
  cancelFeeCommission = _config["default"].cancelFeeCommission;
/** @param { number } amountWithTax */
function getAmountWithoutTax(amountWithTax, country) {
  var tvaRatio = (0, _tvaRatios.getTvaRatioByCountry)(country);
  return (0, _orderPriceUtils.round)(amountWithTax / (1 + tvaRatio));
}

/** @param { number } amountWithoutTax */
function getAmountWithTax(amountWithoutTax, country) {
  var tvaRatio = (0, _tvaRatios.getTvaRatioByCountry)(country);
  return (0, _orderPriceUtils.round)(amountWithoutTax * (1 + tvaRatio));
}

/** @param { number } amountWithoutTax */
function getTVAFromAmountWithoutTax(amountWithoutTax, country) {
  var tvaRatio = (0, _tvaRatios.getTvaRatioByCountry)(country);
  return (0, _orderPriceUtils.round)(amountWithoutTax * tvaRatio);
}

/** @param { number } amountWithTax */
function getTVAFromAmountWithTax(amountWithTax, country) {
  var amountWithoutTax = getAmountWithoutTax(amountWithTax, country);
  return (0, _orderPriceUtils.round)(amountWithTax - amountWithoutTax);
  // use difference rather than ratio (amountWithTax * 0.2 / 1.2) to avoid issue with rounding
  // cf edge case in unit test with 0.57
}

/**
 * @param { import("../entities/types").Item } item
 * @param { number } liningsNumber */
function getAlterationUnitPriceWithLinings(item, liningsNumber) {
  var itemPrice = item.price || 0;
  var liningUnitPrice = item.liningUnitPrice || 0;
  return itemPrice + liningsNumber * liningUnitPrice;
}

/**
 * @param { import("../entities/types").Item } item
 * @param { number } liningsNumber */
function getAlterationTotal(item, liningsNumber) {
  return item.quantity * getAlterationUnitPriceWithLinings(item, liningsNumber);
}

/** @param { import("../entities/types").Cloth } cloth */
function getClothUpcyclingTotal(cloth) {
  var newCloth = typeof cloth.toObject === 'function' ? cloth.toObject() : cloth;
  var _newCloth$liningsNumb = newCloth.liningsNumber,
    liningsNumber = _newCloth$liningsNumb === void 0 ? 0 : _newCloth$liningsNumb,
    _newCloth$upcyclingIt = newCloth.upcyclingItems,
    upcyclingItems = _newCloth$upcyclingIt === void 0 ? [] : _newCloth$upcyclingIt;
  return (0, _orderPriceUtils.round)(upcyclingItems.reduce(function (sum, item) {
    var _item$quantity;
    var newItem = _objectSpread(_objectSpread({}, item), {}, {
      quantity: (_item$quantity = item.quantity) !== null && _item$quantity !== void 0 ? _item$quantity : 1
    });
    return sum + getAlterationTotal(newItem, liningsNumber);
  }, 0));
}

/** @param { import("../entities/types").Cloth } cloth */
function getClothTotal(cloth) {
  var _cloth$items = cloth.items,
    items = _cloth$items === void 0 ? [] : _cloth$items,
    _cloth$customItems = cloth.customItems,
    customItems = _cloth$customItems === void 0 ? [] : _cloth$customItems,
    _cloth$liningsNumber = cloth.liningsNumber,
    liningsNumber = _cloth$liningsNumber === void 0 ? 0 : _cloth$liningsNumber;
  return (0, _orderPriceUtils.round)(items.reduce(function (sum, item) {
    return sum + getAlterationTotal(item, liningsNumber);
  }, 0) + customItems.reduce(function (sum, item) {
    return sum + (parseFloat(item.price) || 0);
  }, 0)) + getClothUpcyclingTotal(cloth);
}

/** @param { import("../entities/types").Order } order */
function getBrandPromoCodes(order) {
  var _order$discounts;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$includesNonPayin = _ref.includesNonPaying,
    includesNonPaying = _ref$includesNonPayin === void 0 ? false : _ref$includesNonPayin;
  var brandPromoCodes = (order === null || order === void 0 ? void 0 : (_order$discounts = order.discounts) === null || _order$discounts === void 0 ? void 0 : _order$discounts.filter(function (discount) {
    return discount.brand;
  })) || [];
  if (!includesNonPaying) {
    return brandPromoCodes.filter(function (discount) {
      return !discount.doesBrandNotPay;
    });
  }
  return brandPromoCodes;
}

/** @param { import("../entities/types").Order } order */
function getBrandPromoCode(order) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$includesNonPayi = _ref2.includesNonPaying,
    includesNonPaying = _ref2$includesNonPayi === void 0 ? false : _ref2$includesNonPayi;
  var brandPromoCodes = getBrandPromoCodes(order, {
    includesNonPaying: includesNonPaying
  });
  return brandPromoCodes[0] || null;
}

// if maxNbPieces is set, the discount is only applied on the maxNbPieces clothes that are the most expensive (total)
function prepareOrderForMaxNbPieces(order) {
  var _order$clothes, _order$clothes2, _cleanedOrder$clothes;
  var brandPromoCodes = getBrandPromoCodes(order);
  if (brandPromoCodes.length === 0) return order;

  // Get the maximum number of pieces across all brand promo codes
  var maxNbPieces = Math.max.apply(Math, _toConsumableArray(brandPromoCodes.map(function (code) {
    return code.maxNbPieces || 0;
  })));
  if (!maxNbPieces || !((_order$clothes = order.clothes) !== null && _order$clothes !== void 0 && _order$clothes.length)) return order;
  if (maxNbPieces >= ((_order$clothes2 = order.clothes) === null || _order$clothes2 === void 0 ? void 0 : _order$clothes2.length)) return order;
  var cleanedOrder = _objectSpread({}, order);

  // sort clothes by total
  cleanedOrder.clothes = (_cleanedOrder$clothes = cleanedOrder.clothes) === null || _cleanedOrder$clothes === void 0 ? void 0 : _cleanedOrder$clothes.map(function (cloth) {
    var total = getClothTotal(cloth);
    return _objectSpread(_objectSpread({}, cloth), {}, {
      total: total
    });
  }).sort(function (a, b) {
    return b.total - a.total;
  });
  var remainingPiecesIndex = maxNbPieces;
  // keep brand: true for all clothes < nbMaxPieces
  cleanedOrder.clothes = cleanedOrder.clothes.map(function (cloth) {
    if (remainingPiecesIndex > 0) {
      if (cloth.brand) {
        remainingPiecesIndex -= 1;
      }
      return cloth;
    }
    return _objectSpread(_objectSpread({}, cloth), {}, {
      brand: false
    });
  });
  return cleanedOrder;
}

/** @param { import("../entities/types").Order } order */
function getTotalPersonalClothes(order) {
  if (!order.clothes) {
    return 0;
  }
  var brandPromoCodes = getBrandPromoCodes(order);

  // Check if any promo code has maxNbPieces
  if (brandPromoCodes.some(function (code) {
    return code.maxNbPieces;
  })) {
    order = prepareOrderForMaxNbPieces(order);
  }
  return (0, _orderPriceUtils.round)(order.clothes.reduce(function (total, cloth) {
    if (!cloth.brand) return total + getClothTotal(cloth);

    // Apply all brand promo codes that have concernsOnly
    var concernsOnlyPromoCodes = brandPromoCodes.filter(function (code) {
      return (0, _orderPrice.hasConcernsOnly)(code);
    });
    if (concernsOnlyPromoCodes.length > 0) {
      var noBrandItems = cloth.items.filter(function (item) {
        return !concernsOnlyPromoCodes.some(function (code) {
          var concernsOnly = code.concernsOnly;
          if (concernsOnly !== null && concernsOnly !== void 0 && concernsOnly.alteration && (0, _orderPrice.isAlteration)(item)) {
            return true;
          }
          if (concernsOnly !== null && concernsOnly !== void 0 && concernsOnly.repair && (0, _orderPrice.isRepair)(item)) {
            return true;
          }
          return false;
        });
      });
      return total + getClothTotal(_objectSpread(_objectSpread({}, cloth), {}, {
        items: noBrandItems
      }));
    }
    return total;
  }, 0));
}

/**
 * @param { import("../entities/types").Order } order
 * @param { import("../entities/types").Discount } [brandPromoCode]
 */
function getTotalBrandClothes(order) {
  var brandPromoCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  if (!order.clothes) {
    return 0;
  }
  var brandPromoCodes = brandPromoCode ? [brandPromoCode] : getBrandPromoCodes(order);

  // Check if any promo code has maxNbPieces
  if (brandPromoCodes.some(function (code) {
    return code.maxNbPieces;
  })) {
    order = prepareOrderForMaxNbPieces(order);
  }
  return (0, _orderPriceUtils.round)(order.clothes.reduce(function (total, cloth) {
    if (!cloth.brand) return total;

    // Apply all brand promo codes that have concernsOnly
    var concernsOnlyPromoCodes = brandPromoCodes.filter(function (code) {
      return (0, _orderPrice.hasConcernsOnly)(code);
    });
    var hasOnlyConcernsOnly = concernsOnlyPromoCodes.length === brandPromoCodes.length;
    if (hasOnlyConcernsOnly && concernsOnlyPromoCodes.length > 0) {
      var brandItems = cloth.items.filter(function (item) {
        return concernsOnlyPromoCodes.some(function (code) {
          var concernsOnly = code.concernsOnly;
          if (concernsOnly !== null && concernsOnly !== void 0 && concernsOnly.alteration && (0, _orderPrice.isAlteration)(item)) {
            return true;
          }
          if (concernsOnly !== null && concernsOnly !== void 0 && concernsOnly.repair && (0, _orderPrice.isRepair)(item)) {
            return true;
          }
          return false;
        });
      });
      return total + getClothTotal(_objectSpread(_objectSpread({}, cloth), {}, {
        items: brandItems
      }));
    }
    return total + getClothTotal(cloth);
  }, 0));
}

/** @param { import("../entities/types").Order } order */
function getTotalClothes(order) {
  return (0, _orderPriceUtils.round)(getTotalBrandClothes(order) + getTotalPersonalClothes(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalPartnerProducts(order) {
  return (order.partnerProducts || []).reduce(function (total, partnerProduct) {
    return total + partnerProduct.price;
  }, 0);
}

/** @param { import("../entities/types").Order } order */
function getInitTotalPersonalClothes(order) {
  if (!order.initBasketClothes) {
    return 0;
  }
  return (0, _orderPriceUtils.round)(order.initBasketClothes.reduce(function (total, cloth) {
    return total + (cloth.brand ? 0 : getClothTotal(cloth));
  }, 0));
}

/** @param { import("../entities/types").Order } order */
function getInitTotalBrandClothes(order) {
  if (!order.initBasketClothes) {
    return 0;
  }
  return (0, _orderPriceUtils.round)(order.initBasketClothes.reduce(function (total, cloth) {
    return total + (cloth.brand ? getClothTotal(cloth) : 0);
  }, 0));
}

/** @param { import("../entities/types").Order } order */
function getInitTotalClothes(order) {
  return (0, _orderPriceUtils.round)(getInitTotalBrandClothes(order) + getInitTotalPersonalClothes(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalRetailProducts(order) {
  var _order$retailProducts;
  return ((_order$retailProducts = order.retailProducts) === null || _order$retailProducts === void 0 ? void 0 : _order$retailProducts.reduce(function (total, retailProduct) {
    var _retailProduct$quanti;
    return total + (retailProduct.price || 0) * ((_retailProduct$quanti = retailProduct.quantity) !== null && _retailProduct$quanti !== void 0 ? _retailProduct$quanti : 1);
  }, 0)) || 0;
}

/** @param { import("../entities/types").Order } order */
function getMinOrderAmountFee(order) {
  var minOrderAmount = typeof order.minOrderAmount === 'number' ? order.minOrderAmount : defaultMinOrderAmount;
  return (0, _orderPriceUtils.round)(Math.max(minOrderAmount - getTotalClothes(order), 0));
}

/** @param { import("../entities/types").Order } order */
function getInitMinOrderAmountFee(order) {
  var minOrderAmount = typeof order.minOrderAmount === 'number' ? order.minOrderAmount : defaultMinOrderAmount;
  return (0, _orderPriceUtils.round)(Math.max(minOrderAmount - getInitTotalClothes(order), 0));
}

/** @param { import("../entities/types").Order } order */
function doesTilliGetDeliveryFee(order) {
  var _order$clothes3;
  if (['PACKAGE', 'PACKAGE_LEATHER_GOODS'].includes(order.process)) return true;
  if (order.deliverySlot) return true;
  return order.onTheSpot && !((_order$clothes3 = order.clothes) !== null && _order$clothes3 !== void 0 && _order$clothes3.find(function (_ref3) {
    var slug = _ref3.slug;
    return slug === 'autr';
  })) || ['RETAIL', 'PARTNER_PRODUCT'].includes(order.process);
}

/** @param { import("../entities/types").Order } order */
function getDeliveryFeesUptrade(order) {
  var _order$partnerProduct = order.partnerProducts,
    partnerProducts = _order$partnerProduct === void 0 ? [] : _order$partnerProduct;
  var refNumber = partnerProducts.length;
  if (refNumber === 0) return 0;
  var meterLength = partnerProducts.reduce(function (total, _ref4) {
    var length = _ref4.length;
    return total + length;
  }, 0);
  if (meterLength === 0) return 0;
  /** @type { import("../entities/types").DeliveryFeePricesUptradeWithoutTax | undefined }  */
  var deliveryFeePrice = _deliveryFeeUptrade["default"].find(function (_ref5) {
    var maxRefNumber = _ref5.maxRefNumber,
      maxMeterLength = _ref5.maxMeterLength;
    return refNumber <= maxRefNumber && meterLength <= maxMeterLength;
  });
  if (deliveryFeePrice === undefined) throw new Error('No delivery fee price found');
  var price = deliveryFeePrice.price;
  return Math.ceil(getAmountWithTax(price, order.country));
}

/** @param { import("../entities/types").Order } order */
function getDeliveryFees(order) {
  if (typeof order.deliveryFee === 'number') return order.deliveryFee;
  if (order.process === 'PARTNER_PRODUCT') return getDeliveryFeesUptrade(order);
  if (['PACKAGE', 'PACKAGE_LEATHER_GOODS'].includes(order.process)) return (0, _orderPricePackage.getPackageDeliveryFees)(order);
  return defaultDeliveryFee;
}

/** @param { import("../entities/types").Order } order */
function getDeliveryFeesTilli(order) {
  return doesTilliGetDeliveryFee(order) ? getDeliveryFees(order) : 0;
}

/** @param { import("../entities/types").Order } order */
function getDeliveryFeesCouturier(order) {
  return doesTilliGetDeliveryFee(order) ? 0 : getDeliveryFees(order);
}

/** @param { import("../entities/types").Order } order */
function getBrandBaseDeliveryFee(order) {
  var deliveryFee = getDeliveryFees(order);
  var totalBrandClothes = getTotalBrandClothes(order);
  var totalPersonalClothes = getTotalPersonalClothes(order);
  if (totalBrandClothes === 0) {
    return 0;
  }
  if (totalPersonalClothes > 0) {
    return (0, _orderPriceUtils.round)(deliveryFee / 2);
  }
  return deliveryFee;
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierMobilization(order) {
  var hourlyAmount = (order.couturierMobilizationRate || 0) * (order.couturierMobilizationDuration || 0);
  var extra = order.couturierMobilizationExtraAmount || 0;
  return hourlyAmount + extra;
}

/** @param { import("../entities/types").Order } order */
function getTotalForCustomer(order) {
  return (0, _orderPriceUtils.round)(getTotalClothes(order) + getTotalRetailProducts(order) + getTotalPartnerProducts(order) + getDeliveryFees(order) + getMinOrderAmountFee(order));
}

/** @param { import("../entities/types").Order } order */
function getInitTotal(order) {
  return (0, _orderPriceUtils.round)(getInitTotalClothes(order) + getDeliveryFees(order) + getInitMinOrderAmountFee(order) + getTotalRetailProducts(order) + getTotalPartnerProducts(order));
}

// not tested and not used(?)
/** @param { import("../entities/types").Order } order */
function getTotalAfterTotalDiscounts(order) {
  var total = getTotalForCustomer(order);
  var rawTotal = order.discounts ? order.discounts.reduce(function (sum, discount) {
    if (discount.brand && !discount.doesBrandNotPay) {
      return sum;
    }
    if (discount.type !== 'TOTAL') {
      return sum;
    }
    if (discount.unit === 'PERCENTAGE') {
      return sum - discount.value / 100 * total;
    }
    return sum - discount.value;
  }, total) : total;
  return Math.max((0, _orderPriceUtils.round)(rawTotal), 0);
}

/** @param { import("../entities/types").Order } order */
function getTotalBaseBrand(order) {
  return getTotalBrandClothes(order) + getTotalCouturierMobilization(order) + getBrandBaseDeliveryFee(order);
}

/** @param { import("../entities/types").Order } order */
function getDiscountValueForBrand(order) {
  var _order$discounts2;
  if (!(((_order$discounts2 = order.discounts) === null || _order$discounts2 === void 0 ? void 0 : _order$discounts2.length) > 0)) return 0;
  var discountOnBrand = order.discounts.find(function (discount) {
    return discount.type === 'FOR_BRAND';
  });
  if (!discountOnBrand) return 0;
  var totalBaseBrand = getTotalBaseBrand(order) - getDeliveryFees(order);
  return discountOnBrand.unit === 'EUROS' ? discountOnBrand.value : totalBaseBrand * discountOnBrand.value / 100;
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {import("../entities/types").Discount | undefined}
 */
var getRepairBonusDiscount = function getRepairBonusDiscount(order) {
  var _order$discounts3;
  return (_order$discounts3 = order.discounts) === null || _order$discounts3 === void 0 ? void 0 : _order$discounts3.find(function (discount) {
    return discount.reason === 'REPAIR_BONUS';
  });
};

/**
 * @param { import("../entities/types").Order } order
 * @returns {Array<{cloth: import("../entities/types").Cloth, remaining: number, total: number}>}
 */
function initializeRemainingAmountsPerCloth(order) {
  var repairBonusDiscount = getRepairBonusDiscount(order);
  return (order.clothes || []).filter(function (cloth) {
    return cloth.brand;
  }).map(function (cloth) {
    return {
      cloth: cloth,
      remaining: getClothTotal(cloth) - (repairBonusDiscount ? (0, _orderPriceUtils.getAmountForDiscountOnItem)(_objectSpread(_objectSpread({}, order), {}, {
        clothes: [cloth]
      }), repairBonusDiscount, true) : 0),
      total: getClothTotal(cloth) - (repairBonusDiscount ? (0, _orderPriceUtils.getAmountForDiscountOnItem)(_objectSpread(_objectSpread({}, order), {}, {
        clothes: [cloth]
      }), repairBonusDiscount, true) : 0)
    };
  }).sort(function (a, b) {
    return b.total - a.total;
  }); // Sort by total descending
}

/**
 * @param { import("../entities/types").Order } order
 * @param { boolean } excludeDeliveryFee
 * @returns {number}
 */
function getTotalBaseBrandForTotalPaidBrand(order) {
  var excludeDeliveryFee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var totalBaseBrand = excludeDeliveryFee ? getTotalBrandClothes(order) + getTotalCouturierMobilization(order) : getTotalBaseBrand(order);
  var repairBonusDiscount = getRepairBonusDiscount(order);
  if (repairBonusDiscount) {
    totalBaseBrand = Math.max(0, totalBaseBrand - (0, _orderPriceUtils.getAmountForDiscountOnItem)(order, repairBonusDiscount, true));
  }
  return totalBaseBrand;
}
/**
 * @param { import("../entities/types").Order } order
 * @param { Array<import("../entities/types").Discount> } brandPromoCodes
 * @param { Array<{cloth: import("../entities/types").Cloth, remaining: number, total: number}> } remainingPerCloth
 * @returns {number}
 */
function getTotalClothesForBrandPayment(order, brandPromoCodes, remainingPerCloth) {
  var totalClothes = remainingPerCloth.reduce(function (sum, _ref6) {
    var total = _ref6.total;
    return sum + total;
  }, 0);
  var hasAllConcernsOnly = brandPromoCodes.every(function (brandPromoCode) {
    return (0, _orderPrice.hasConcernsOnly)(brandPromoCode);
  });
  if (hasAllConcernsOnly) {
    var concernsOnlyDiscount = brandPromoCodes.find(function (brandPromoCode) {
      return (0, _orderPrice.hasConcernsOnly)(brandPromoCode);
    });
    totalClothes = concernsOnlyDiscount ? (0, _orderPrice.getConcernsOnlyAmount)(order, concernsOnlyDiscount) : totalClothes;
  }
  return totalClothes;
}
/**
 * @param { import("../entities/types").Order } order
 * @param { import("../entities/types").Discount } brandPromoCode
 * @returns {number}
 */
function getItemIdsDiscountAmount(order, brandPromoCode) {
  var itemIds = brandPromoCode.itemIds || [];
  if (itemIds.length > 0 && order.clothes) {
    var brandItems = order.clothes.flatMap(function (cloth) {
      return cloth.items.filter(function (item) {
        return itemIds.includes(item.id);
      });
    });
    var totalBrandItems = getClothTotal(_objectSpread(_objectSpread({}, order.clothes[0]), {}, {
      items: brandItems
    }));
    return brandPromoCode.unit === 'PERCENTAGE' ? (0, _orderPriceUtils.round)(brandPromoCode.value / 100 * totalBrandItems) : Math.min(brandPromoCode.value, totalBrandItems);
  }
  return 0;
}
/**
 * @param { Array<{cloth: import("../entities/types").Cloth, remaining: number, total: number}> } remainingPerCloth
 * @param { number } maxNbPieces
 * @returns {Array<{cloth: import("../entities/types").Cloth, remaining: number, total: number}>}
 */
function getApplicableCloths(remainingPerCloth, maxNbPieces) {
  return remainingPerCloth.filter(function (item) {
    return item.remaining > 0;
  }) // Only consider clothes with remaining amount
  .slice(0, maxNbPieces);
}
/**
 * @param { Array<{cloth: import("../entities/types").Cloth, remaining: number, total: number}> } applicableCloths
 * @param { number } remainingMobilizationAndDelivery
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function handle100PercentDiscount(applicableCloths, remainingMobilizationAndDelivery, order) {
  // For 100% discount, take all remaining amounts for applicable clothes
  var amount = applicableCloths.reduce(function (sum, item) {
    var clothAmount = item.remaining;
    item.remaining = 0;
    return sum + clothAmount;
  }, 0) - getDiscountValueForBrand(order);

  // Add mobilization and delivery fees if this is the first 100% discount
  if (remainingMobilizationAndDelivery > 0) {
    var mobilizationAmount = remainingMobilizationAndDelivery;
    return amount + mobilizationAmount;
  }
  return amount;
}

/**
 * @param { import("../entities/types").Discount } brandPromoCode
 * @param { Array<{cloth: import("../entities/types").Cloth, remaining: number, total: number}> } applicableCloths
 * @param { number } mobilizationAndDelivery
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function handleConcernsOnlyPercentageDiscount(brandPromoCode, applicableCloths, mobilizationAndDelivery, order) {
  var concernedCloths = applicableCloths.map(function (_ref7) {
    var cloth = _ref7.cloth;
    var items = cloth.items.filter(function (item) {
      var concernsOnly = brandPromoCode.concernsOnly;
      return (concernsOnly === null || concernsOnly === void 0 ? void 0 : concernsOnly.alteration) && (0, _orderPrice.isAlteration)(item) || (concernsOnly === null || concernsOnly === void 0 ? void 0 : concernsOnly.repair) && (0, _orderPrice.isRepair)(item);
    });
    return _objectSpread(_objectSpread({}, cloth), {}, {
      items: items
    });
  });
  var concernedTotal = concernedCloths.reduce(function (sum, cloth) {
    return sum + getClothTotal(cloth);
  }, 0);
  return (0, _orderPriceUtils.round)(brandPromoCode.value / 100 * concernedTotal) + mobilizationAndDelivery - getDiscountValueForBrand(order);
}

/**
 * Applies a fixed discount to applicable clothes and returns the total discount amount
 *
 * @param { Array<{cloth: import("../entities/types").Cloth, remaining: number, total: number}> } applicableCloths
 * @param { number } remainingDiscount
 * @returns {{ amount: number, remainingDiscount: number }}
 */
function applyFixedDiscountToClothes(applicableCloths, remainingDiscount) {
  // Apply fixed discount to each applicable cloth's remaining amount
  var amount = applicableCloths.reduce(function (sum, item) {
    if (remainingDiscount <= 0) return sum;
    var discountAmount = Math.min(remainingDiscount, item.remaining);
    item.remaining = Math.max(0, item.remaining - discountAmount);
    remainingDiscount = Math.max(0, remainingDiscount - discountAmount);
    return sum + discountAmount;
  }, 0);
  return {
    amount: amount,
    remainingDiscount: remainingDiscount
  };
}

/** @param { import("../entities/types").Order } order */
function getTotalPaidBrand(order) {
  var excludeDeliveryFee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var brandPromoCodes = getBrandPromoCodes(order);
  if (brandPromoCodes.length === 0) return 0;

  // Initialize remaining amounts per cloth
  var remainingPerCloth = initializeRemainingAmountsPerCloth(order);

  // Calculate total paid for each brand promo code cumulatively
  var totalPaid = 0;
  var totalBaseBrand = getTotalBaseBrandForTotalPaidBrand(order, excludeDeliveryFee);
  var totalClothes = getTotalClothesForBrandPayment(order, brandPromoCodes, remainingPerCloth);
  var mobilizationAndDelivery = Math.max(0, totalBaseBrand + getMinOrderAmountFee(order) - totalClothes);
  var remainingMobilizationAndDelivery = mobilizationAndDelivery;
  brandPromoCodes.forEach(function (brandPromoCode) {
    // If this discount has doesExcludeDeliveryFee, recalculate base without delivery fee
    var localTotalBaseBrand = totalBaseBrand;
    var localMobilizationAndDelivery = mobilizationAndDelivery;
    var localRemainingMobilizationAndDelivery = remainingMobilizationAndDelivery;
    if (brandPromoCode.doesExcludeDeliveryFee) {
      // Remove delivery fee from base for this discount
      var deliveryFee = getDeliveryFees(order);
      localTotalBaseBrand = Math.max(0, localTotalBaseBrand - deliveryFee);
      localMobilizationAndDelivery = Math.max(0, localTotalBaseBrand + getMinOrderAmountFee(order) - totalClothes);
      localRemainingMobilizationAndDelivery = localMobilizationAndDelivery;
    }

    // Handle itemIds specific discounts
    var itemIds = brandPromoCode.itemIds || [];
    if (itemIds.length > 0 && order.clothes) {
      totalPaid += getItemIdsDiscountAmount(order, brandPromoCode);
      return;
    }

    // Handle maxNbPieces
    var maxNbPieces = brandPromoCode.maxNbPieces || remainingPerCloth.length;
    var applicableCloths = getApplicableCloths(remainingPerCloth, maxNbPieces);
    if (brandPromoCode.unit === 'PERCENTAGE') {
      if (brandPromoCode.value === 100 && !(0, _orderPrice.hasConcernsOnly)(brandPromoCode)) {
        var result = handle100PercentDiscount(applicableCloths, localRemainingMobilizationAndDelivery, order);
        remainingMobilizationAndDelivery = 0;
        totalPaid += result;
        return;
      }
      if ((0, _orderPrice.hasConcernsOnly)(brandPromoCode)) {
        totalPaid += handleConcernsOnlyPercentageDiscount(brandPromoCode, applicableCloths, localMobilizationAndDelivery, order);
        return;
      }

      // Apply percentage discount to each applicable cloth's total amount
      var _amount = applicableCloths.reduce(function (sum, item) {
        var discountAmount = Math.min((0, _orderPriceUtils.round)(brandPromoCode.value / 100 * item.total), item.remaining);
        item.remaining = Math.max(0, item.remaining - discountAmount);
        return sum + discountAmount;
      }, 0);

      // Apply percentage to full mobilization and delivery amount
      var _mobilizationAmount = (0, _orderPriceUtils.round)(brandPromoCode.value / 100 * (localMobilizationAndDelivery - getMinOrderAmountFee(order)));
      remainingMobilizationAndDelivery = Math.max(0, remainingMobilizationAndDelivery - _mobilizationAmount);
      totalPaid += _amount + _mobilizationAmount - getDiscountValueForBrand(order);
      return;
    }

    // Handle fixed amount discounts
    var remainingDiscount = brandPromoCode.value;
    if ((0, _orderPrice2.hasMaxOnClothSlug)(brandPromoCode)) {
      remainingDiscount = (0, _orderPrice2.getMaxOnClothSlug)(order, brandPromoCode);
    }
    if ((0, _orderPrice.hasConcernsOnly)(brandPromoCode)) {
      remainingDiscount = (0, _orderPrice.getConcernsOnlyDiscountAmount)(order, brandPromoCode);
    }
    var discountOnItems = brandPromoCode.discountOnItems || [];
    if (discountOnItems.length > 0) {
      remainingDiscount += (0, _orderPriceUtils.getAmountForDiscountOnItem)(order, brandPromoCode);
    }
    if (brandPromoCode.unit === 'EUROS' && brandPromoCode.valuePer === 'order' && remainingDiscount > brandPromoCode.value) {
      remainingDiscount = brandPromoCode.value;
    }
    var _applyFixedDiscountTo = applyFixedDiscountToClothes(applicableCloths, remainingDiscount),
      amount = _applyFixedDiscountTo.amount,
      updatedRemainingDiscount = _applyFixedDiscountTo.remainingDiscount;
    remainingDiscount = updatedRemainingDiscount;

    // Apply remaining discount to mobilization and delivery if any left
    var mobilizationAmount = 0;
    if (remainingDiscount > 0 && localRemainingMobilizationAndDelivery > 0) {
      mobilizationAmount = Math.min(remainingDiscount, localRemainingMobilizationAndDelivery - getMinOrderAmountFee(order));
      remainingMobilizationAndDelivery = Math.max(0, remainingMobilizationAndDelivery - mobilizationAmount);
    }
    totalPaid += amount + mobilizationAmount;
  });
  if (brandPromoCodes.some(function (brandPromoCode) {
    return brandPromoCode.doesExcludeDeliveryFee;
  })) {
    // Subtract repair bonus discount from total paid
    var repairBonusDiscount = getRepairBonusDiscount(order);
    if (repairBonusDiscount) {
      totalPaid = Math.max(0, totalPaid - (0, _orderPriceUtils.getAmountForDiscountOnItem)(order, repairBonusDiscount, true));
    }
  }
  return totalPaid;
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getTotalCashCollection(order) {
  if (!order.discounts || order.discounts.length === 0) return 0;
  var orderWithOnlyCashCollectionPromoCodes = _objectSpread(_objectSpread({}, order), {}, {
    discounts: order.discounts.filter(function (discount) {
      return discount.brandStatus === 'CASH_COLLECTION';
    })
  });
  return getTotalPaidBrand(orderWithOnlyCashCollectionPromoCodes);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getTotalBrandRevenue(order) {
  return getTotalPaidBrand(order) - getTotalCashCollection(order);
}

// TODO: unit testing
/** @param { import("../entities/types").Order } order */
function getDeliveryFeePaidBrand(order) {
  return (0, _orderPriceUtils.round)(getTotalPaidBrand(order) - getTotalPaidBrand(order, true));
}

// TODO: unit testing
/** @param { import("../entities/types").Order } order */
function getDeliveryFeePaidCustomer(order) {
  return (0, _orderPriceUtils.round)(getDeliveryFees(order) - getDeliveryFeePaidBrand(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalBaseCustomer(order) {
  return (0, _orderPriceUtils.round)(getTotalForCustomer(order) - getTotalPaidBrand(order) - getDiscountValueForBrand(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalBaseCustomerAfterTotalDiscounts(order) {
  var total = getTotalBaseCustomer(order);
  var rawTotal = order.discounts ? order.discounts.reduce(function (sum, discount) {
    if (discount.brand && !discount.doesBrandNotPay) {
      return sum;
    }
    if (discount.type !== 'TOTAL') {
      return sum;
    }
    if ((0, _orderPrice2.hasMaxOnClothSlug)(discount)) {
      var maxOnClothSlug = (0, _orderPrice2.getMaxOnClothSlug)(order, discount);
      return sum - maxOnClothSlug;
    }
    if (discount.unit === 'PERCENTAGE' && (0, _orderPrice.hasConcernsOnly)(discount)) {
      var concernsOnlyAmount = (0, _orderPrice.getConcernsOnlyAmount)(order, discount);
      return sum - discount.value / 100 * concernsOnlyAmount;
    }
    if (discount.unit === 'PERCENTAGE') {
      var totalWithoutDeliveryFee = discount.doesExcludeDeliveryFee ? total - getDeliveryFees(order) : total;
      return sum - discount.value / 100 * totalWithoutDeliveryFee;
    }
    if ((0, _orderPrice.hasConcernsOnly)(discount)) {
      var concernsOnlyDiscountAmount = (0, _orderPrice.getConcernsOnlyDiscountAmount)(order, discount);
      return sum - concernsOnlyDiscountAmount;
    }
    if (discount.discountOnItems && discount.discountOnItems.length > 0) return sum - (0, _orderPriceUtils.getAmountForDiscountOnItem)(order, discount);
    return Math.max(sum - discount.value, discount.doesExcludeDeliveryFee ? getDeliveryFees(order) : 0);
  }, total) : total;
  return Math.max((0, _orderPriceUtils.round)(rawTotal), 0);
}

/** @param { import("../entities/types").Order } order */
function getTotalBaseCustomerAfterTotalDiscountsWithoutDiscountVouchers(order) {
  var total = getTotalBaseCustomer(order);
  var rawTotal = order.discounts ? order.discounts.reduce(function (sum, discount) {
    if (discount.name && (discount.name.toLowerCase().includes('parrainage') || discount.name.toLowerCase().includes('filleul'))) {
      return sum;
    }
    if (discount.brand && !discount.doesBrandNotPay) {
      return sum;
    }
    if (discount.type !== 'TOTAL') {
      return sum;
    }
    if (discount.unit === 'PERCENTAGE') {
      return sum - discount.value / 100 * total;
    }
    return sum - discount.value;
  }, total) : total;
  return Math.max((0, _orderPriceUtils.round)(rawTotal), 0);
}

/**
 * @param { import("../entities/types").Order } order
 * @return {number}
 */
function getDeliveryFeePaidCustomerAfterTotalDiscounts(order) {
  var total = getDeliveryFeePaidCustomer(order);
  var rawTotal = order.discounts ? order.discounts.reduce(function (sum, discount) {
    if (discount.brand && !discount.doesBrandNotPay) {
      return sum;
    }
    if (discount.type !== 'TOTAL') {
      return sum;
    }
    if ((0, _orderPrice.hasConcernsOnly)(discount)) {
      return sum;
    }
    if (discount.unit === 'PERCENTAGE') {
      var totalWithoutDeliveryFee = discount.doesExcludeDeliveryFee ? total - getDeliveryFees(order) : total;
      return sum - discount.value / 100 * totalWithoutDeliveryFee;
    }
    return Math.max(sum - discount.value, discount.doesExcludeDeliveryFee ? getDeliveryFees(order) : 0);
  }, total) : total;
  return Math.max((0, _orderPriceUtils.round)(rawTotal), 0);
}

/**
 * @param { import("../entities/types").Order } order
 * @param { import("../entities/types").Discount } discount
 * @return {boolean}
 */
function doesDeliveryMatchesDiscount(order, discount) {
  var _discount$deliveryFee, _discount$deliveryFee2, _discount$deliveryFee3, _discount$deliveryFee4;
  if (!discount.deliveryFee || !(((_discount$deliveryFee = discount.deliveryFee) === null || _discount$deliveryFee === void 0 ? void 0 : _discount$deliveryFee.value) > 0)) return false;
  if (!order.transporterChosenByCustomer) return Boolean((_discount$deliveryFee2 = discount.deliveryFee) === null || _discount$deliveryFee2 === void 0 ? void 0 : _discount$deliveryFee2.forAtHome);
  if (order.transporterChosenByCustomer === 'COLISSIMO') return Boolean((_discount$deliveryFee3 = discount.deliveryFee) === null || _discount$deliveryFee3 === void 0 ? void 0 : _discount$deliveryFee3.forColissimo);
  if (order.transporterChosenByCustomer === 'MONDIAL_RELAY') return Boolean((_discount$deliveryFee4 = discount.deliveryFee) === null || _discount$deliveryFee4 === void 0 ? void 0 : _discount$deliveryFee4.forMondialRelay);
  return false;
}

/** @param { import("../entities/types").Order } order */
function getTotalPaid(order) {
  var total = getTotalBaseCustomerAfterTotalDiscounts(order);
  var deliveryFees = getDeliveryFees(order);
  var insuranceFees = order.transporterInsurance ? order.transporterInsurance.amount * 2 : 0;
  var rawTotal = order.discounts ? order.discounts.reduce(function (sumAcc, discount) {
    var sum = sumAcc;
    if (discount.deliveryFee && doesDeliveryMatchesDiscount(order, discount)) {
      var _discount$deliveryFee5;
      var discountableDeliveryFee = deliveryFees - insuranceFees;
      if (((_discount$deliveryFee5 = discount.deliveryFee) === null || _discount$deliveryFee5 === void 0 ? void 0 : _discount$deliveryFee5.unit) === 'PERCENTAGE') {
        sum = sumAcc - discount.deliveryFee.value / 100 * discountableDeliveryFee;
      } else {
        var discountOnDeliveryFee = discount.deliveryFee.value > discountableDeliveryFee ? discountableDeliveryFee : discount.deliveryFee.value;
        sum = sumAcc - discountOnDeliveryFee;
      }
    }
    if (discount.brand && !discount.doesBrandNotPay) {
      if (discount.doesTilliOfferDeliveryFees) {
        return sum - deliveryFees;
      }
      return sum;
    }
    if (discount.type === 'TOTAL') {
      return sum;
    }
    if ((0, _orderPrice2.hasMaxOnClothSlug)(discount)) {
      var maxOnClothSlug = (0, _orderPrice2.getMaxOnClothSlug)(order, discount);
      return sum - maxOnClothSlug;
    }
    if (discount.unit === 'PERCENTAGE' && !discount.doesExcludeDeliveryFee) {
      return sum - discount.value / 100 * total;
    }
    if (discount.unit === 'PERCENTAGE' && discount.doesExcludeDeliveryFee) {
      var totalWithoutDeliveryFee = total - deliveryFees;
      return sum - discount.value / 100 * totalWithoutDeliveryFee;
    }
    if (discount.discountOnItems && discount.discountOnItems.length > 0) {
      return sum - (0, _orderPriceUtils.getAmountForDiscountOnItem)(order, discount);
    }
    return Math.max(sum - discount.value, discount.doesExcludeDeliveryFee ? deliveryFees : 0);
  }, total) : total;
  return Math.max((0, _orderPriceUtils.round)(rawTotal), 0);
}

/** @param { import("../entities/types").Order } order */
function getTotalPaidWithoutDiscountVouchers(order) {
  var total = getTotalBaseCustomerAfterTotalDiscountsWithoutDiscountVouchers(order);
  var rawTotal = order.discounts ? order.discounts.reduce(function (sum, discount) {
    if (discount.name && (discount.name.toLowerCase().includes('parrainage') || discount.name.toLowerCase().includes('filleul'))) {
      return sum;
    }
    if (discount.brand && !discount.doesBrandNotPay) {
      return sum;
    }
    if (discount.type === 'TOTAL') {
      return sum;
    }
    if (discount.unit === 'PERCENTAGE') {
      return sum - discount.value / 100 * total;
    }
    return sum - discount.value;
  }, total) : total;
  return Math.max((0, _orderPriceUtils.round)(rawTotal), 0);
}

/** @param { import("../entities/types").Order } order */
function getPackageCommissionForMostExpensiveCustomer(order) {
  if (order.process !== 'AT_SHOP' || !order.clothes || order.clothes.length === 0) return 0;
  var clothesTotalByCustomer = order.clothes.reduce(function (acc, cloth) {
    var _cloth$customer, _cloth$customer$_id;
    var customer = 'default';
    if (typeof cloth.customer === 'string') {
      customer = cloth.customer;
    } else if (typeof ((_cloth$customer = cloth.customer) === null || _cloth$customer === void 0 ? void 0 : (_cloth$customer$_id = _cloth$customer._id) === null || _cloth$customer$_id === void 0 ? void 0 : _cloth$customer$_id.toString()) === 'string') customer = cloth.customer._id.toString();
    // @ts-ignore
    if (!acc[customer]) acc[customer] = 0;
    // @ts-ignore
    acc[customer] += getClothTotal(cloth);
    return acc;
  }, {});
  var mostExpensiveCustomerAmount = Math.max.apply(Math, _toConsumableArray(Object.values(clothesTotalByCustomer)));
  var ratioForMostExpensiveCustomer = -0.12;
  return (0, _orderPriceUtils.round)(mostExpensiveCustomerAmount * ratioForMostExpensiveCustomer);
}

/** @param { import("../entities/types").Order } order */
function getCommissionRatio(order) {
  // extra 8% on pickup for "épinglage/conseil" + extra 12% for second rank customers (all except the most expensive customer)
  if (order.process === 'AT_SHOP' && order.pricingModelVersionAtShop === 2) return 0.50;

  // extra 8% on retail_freelance for "épinglage/conseil"
  if (order.process === 'RETAIL_FREELANCE' && order.pricingModelVersionRetailFreelance === 2) return 0.38;
  if (typeof order.commissionRatio === 'number') return order.commissionRatio;
  if (order.process === 'PARTNER_PRODUCT') return 1;
  if (order.process === 'RETAIL') return 1;
  if (order.country === 'BE') return 0.3817;
  return defaultCommissionRatio;
}

/** @param { import("../entities/types").Order } order */
function getCommissionBrand(order) {
  var commissionRatio = getCommissionRatio(order);
  var rawTotal = getTotalPaidBrand(order, true) * commissionRatio;
  rawTotal -= getDiscountValueForBrand(order) * commissionRatio;
  if (order.process === 'AT_SHOP' && order.pricingModelVersionAtShop === 2) rawTotal += getPackageCommissionForMostExpensiveCustomer(order);
  if (doesTilliGetDeliveryFee(order)) {
    return (0, _orderPriceUtils.round)(rawTotal + getDeliveryFeePaidBrand(order));
  }
  return (0, _orderPriceUtils.round)(rawTotal);
}

/** @param { import("../entities/types").Order } order */
function getCommissionBrandWithTax(order) {
  var commissionRatio = getCommissionRatio(order);
  var rawTotal = getTotalPaidBrand(order, true) * commissionRatio;
  rawTotal -= getDiscountValueForBrand(order) * commissionRatio;
  if (order.process === 'AT_SHOP' && order.pricingModelVersionAtShop === 2) rawTotal += getPackageCommissionForMostExpensiveCustomer(order);
  var tvaRatio = (0, _tvaRatios.getTvaRatioByCountry)(order.country);
  var taxFactor = order.doesBrandPayTVAonAll ? 1 + tvaRatio : 1;
  if (doesTilliGetDeliveryFee(order)) {
    var feesWithTax = (0, _orderPriceUtils.round)(getDeliveryFeePaidBrand(order) * taxFactor);
    return (0, _orderPriceUtils.round)(rawTotal * taxFactor + feesWithTax);
  }
  return (0, _orderPriceUtils.round)(rawTotal * taxFactor);
}

/** @param { import("../entities/types").Order } order */
function getCommissionCustomer(order) {
  var deliveryFee = getDeliveryFeePaidCustomerAfterTotalDiscounts(order);
  var rawTotalForCommission = getTotalBaseCustomerAfterTotalDiscounts(order) - deliveryFee - getTotalRetailProducts(order);
  var commissionRatio = getCommissionRatio(order);
  var commissionWithoutCommissionDiscounts = rawTotalForCommission * commissionRatio;
  var insuranceFees = order.transporterInsurance ? order.transporterInsurance.amount * 2 : 0;
  var commission = order.discounts ? order.discounts.reduce(function (sumAcc, discount) {
    var sum = sumAcc;
    if (discount.brand && !discount.doesBrandNotPay) {
      if (discount.doesTilliOfferDeliveryFees) {
        return sum - getDeliveryFees(order);
      }
      return sum;
    }
    if (discount.deliveryFee && doesDeliveryMatchesDiscount(order, discount)) {
      var _discount$deliveryFee6;
      var discountableDeliveryFee = getDeliveryFees(order) - insuranceFees;
      if (((_discount$deliveryFee6 = discount.deliveryFee) === null || _discount$deliveryFee6 === void 0 ? void 0 : _discount$deliveryFee6.unit) === 'PERCENTAGE') {
        sum = sumAcc - discount.deliveryFee.value / 100 * discountableDeliveryFee;
      } else {
        var discountOnDeliveryFee = discount.deliveryFee.value > discountableDeliveryFee ? discountableDeliveryFee : discount.deliveryFee.value;
        sum = sumAcc - discountOnDeliveryFee;
      }
    }
    if (discount.type === 'COMMISSION' && (0, _orderPrice2.hasMaxOnClothSlug)(discount)) {
      var maxOnClothSlug = (0, _orderPrice2.getMaxOnClothSlug)(order, discount);
      return sum - maxOnClothSlug;
    }
    if (discount.type !== 'COMMISSION') {
      return sum;
    }
    if (discount.unit === 'PERCENTAGE') {
      return sum - discount.value / 100 * rawTotalForCommission;
    }
    if (discount.discountOnItems && discount.discountOnItems.length > 0) {
      return sum - (0, _orderPriceUtils.getAmountForDiscountOnItem)(order, discount);
    }
    return sum - discount.value;
  }, commissionWithoutCommissionDiscounts) : commissionWithoutCommissionDiscounts;
  if (doesTilliGetDeliveryFee(order)) {
    commission += deliveryFee;
  }
  commission += getTotalRetailProducts(order);
  return Math.max((0, _orderPriceUtils.round)(commission), 0);
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierCustomer(order) {
  if (order.process === 'PARTNER_PRODUCT') return 0;
  return (0, _orderPriceUtils.round)(getTotalPaid(order) - getCommissionCustomer(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierBrand(order) {
  if (order.process === 'PARTNER_PRODUCT') return 0;
  return (0, _orderPriceUtils.round)(getTotalPaidBrand(order) - getCommissionBrand(order));
}

/** @param { import("../entities/types").Order } order */
function getMinTotalCouturier(order) {
  if (order.process === 'PARTNER_PRODUCT') return 0;
  return typeof order.minTotalCouturier === 'number' ? order.minTotalCouturier : defaultMinTotalCouturier;
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierLostOnCommissionDiscount(order) {
  if (order.process === 'PARTNER_PRODUCT') return 0;
  var newOrder = order.toObject ? order.toObject({
    virtuals: false
  }) : _objectSpread({}, order);
  newOrder.discounts = newOrder.discounts ? newOrder.discounts.filter(function (discount) {
    return !['COMMISSION', 'FOR_BRAND'].includes(discount.type);
  }) : [];
  var normalTotalCouturier = getTotalCouturierCustomer(newOrder) + getTotalCouturierBrand(newOrder);
  var totalCouturier = getTotalCouturierCustomer(order) + getTotalCouturierBrand(order);
  return Math.max((0, _orderPriceUtils.round)(normalTotalCouturier - totalCouturier), 0);
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierTilli(order) {
  var otherTotalCouturier = (0, _orderPriceUtils.round)(getTotalCouturierCustomer(order) + getTotalCouturierBrand(order));
  var minTotalCouturier = doesTilliGetDeliveryFee(order) ? getMinTotalCouturier(order) : getMinTotalCouturier(order) + getDeliveryFees(order);
  var lostOnCommissionDiscount = getTotalCouturierLostOnCommissionDiscount(order);
  var minTotalCouturierWithLostOnDiscount = Math.max((0, _orderPriceUtils.round)(minTotalCouturier - lostOnCommissionDiscount - otherTotalCouturier), 0);
  return Math.max((0, _orderPriceUtils.round)(minTotalCouturierWithLostOnDiscount + lostOnCommissionDiscount), 0);
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierTilliForRepairBonus(order) {
  var orderWithoutRepairBonus = _objectSpread(_objectSpread({}, order), {}, {
    discounts: order.discounts ? order.discounts.filter(function (discount) {
      return discount.reason !== 'REPAIR_BONUS';
    }) : []
  });
  var lostOnCommissionDiscount = getTotalCouturierLostOnCommissionDiscount(order);
  var lostOnCommissionDiscountWithoutRepairBonus = getTotalCouturierLostOnCommissionDiscount(orderWithoutRepairBonus);
  return Math.max((0, _orderPriceUtils.round)(lostOnCommissionDiscount - lostOnCommissionDiscountWithoutRepairBonus), 0);
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierTilliForMinTotalCouturier(order) {
  var minTotalCouturier = getMinTotalCouturier(order);
  var otherTotalCouturier = (0, _orderPriceUtils.round)(getTotalCouturierCustomer(order) + getTotalCouturierBrand(order) + getTotalCouturierTilliForRepairBonus(order));
  return Math.max((0, _orderPriceUtils.round)(minTotalCouturier - otherTotalCouturier), 0);
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierTilliOther(order) {
  return (0, _orderPriceUtils.round)(getTotalCouturierTilli(order) - getTotalCouturierTilliForMinTotalCouturier(order) - getTotalCouturierTilliForRepairBonus(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturier(order) {
  if (order.process === 'PARTNER_PRODUCT') return 0;
  return (0, _orderPriceUtils.round)(getTotalCouturierCustomer(order) + getTotalCouturierBrand(order) + getTotalCouturierTilli(order));
}

/** @param { import("../entities/types").Order } order */
function getCommission(order) {
  return (0, _orderPriceUtils.round)(getCommissionBrand(order) + getCommissionCustomer(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierTilliAndCustomer(order) {
  return (0, _orderPriceUtils.round)(getTotalCouturierCustomer(order) + getTotalCouturierTilli(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalDiscount(order) {
  return (0, _orderPriceUtils.round)(getTotalForCustomer(order) - getTotalPaid(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierDiscount(order) {
  var orderWithoutDiscounts = order.toObject ? order.toObject({
    virtuals: false
  }) : _objectSpread({}, order);
  orderWithoutDiscounts.discounts = [];
  return (0, _orderPriceUtils.round)(getTotalCouturier(orderWithoutDiscounts) - getTotalCouturier(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalCouturierCustomerDiscount(order) {
  var orderWithoutDiscounts = order.toObject ? order.toObject({
    virtuals: false
  }) : _objectSpread({}, order);
  orderWithoutDiscounts.discounts = [];
  return (0, _orderPriceUtils.round)(getTotalCouturierCustomer(orderWithoutDiscounts) - getTotalCouturierCustomer(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalCommissionDiscount(order) {
  return (0, _orderPriceUtils.round)(getTotalDiscount(order) - getTotalCouturierDiscount(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalCommissionCustomerDiscount(order) {
  var orderWithoutDiscounts = order.toObject ? order.toObject({
    virtuals: false
  }) : _objectSpread({}, order);
  orderWithoutDiscounts.discounts = [];
  return (0, _orderPriceUtils.round)(getCommissionCustomer(orderWithoutDiscounts) - getCommissionCustomer(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalDiscountPromoCode(order) {
  return (0, _orderPriceUtils.round)(getTotalForCustomer(order) - getTotalPaidWithoutDiscountVouchers(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalDiscountDiscountVouchers(order) {
  return (0, _orderPriceUtils.round)(getTotalPaidWithoutDiscountVouchers(order) - getTotalPaid(order));
}

/**
 * @param { number } nbCancelling
 */
function getCancelFee(nbCancelling) {
  return (0, _orderPriceUtils.round)(nbCancelling * cancelFee);
}
function getUnitCancelFeeCommissionWithoutTax() {
  return cancelFeeCommission;
}
function getUnitCancelFeeCommissionWithTax(country) {
  return getAmountWithTax(cancelFeeCommission, country);
}

/** @param { number } nbCancelling */
function getCancelFeeCommissionWithoutTax(nbCancelling) {
  return (0, _orderPriceUtils.round)(nbCancelling * cancelFeeCommission);
}

/** @param { number } nbCancelling */
function getCancelFeeCommissionWithTax(nbCancelling, country) {
  return (0, _orderPriceUtils.round)(nbCancelling * getUnitCancelFeeCommissionWithTax(country));
}

/**
 * @param { number } nbCancelling
 * @param { import("../entities/types").Order } order
 */
function getCommissionCustomerWithCancelFeeWithTax(order, nbCancelling) {
  return (0, _orderPriceUtils.round)(getCommissionCustomer(order) + getCancelFeeCommissionWithTax(nbCancelling, order.country));
}

/**
 * @param { number } nbCancelling
 * @param { import("../entities/types").Order } order
 */
function getTotalCouturierCustomerWithCancelFeeWithTax(order, nbCancelling) {
  var cancelFeeCouturier = getCancelFee(nbCancelling) - getCancelFeeCommissionWithTax(nbCancelling, order.country);
  return (0, _orderPriceUtils.round)(getTotalCouturierCustomer(order) + cancelFeeCouturier);
}

/** @param { import("../entities/types").Order } order */
function getTaxOnCommission(order) {
  if (order.process === 'RETAIL') return getTVAFromAmountWithTax(getTotalForCustomer(order), order.country);
  return getTVAFromAmountWithTax(getCommission(order), order.country);
}

/** @param { import("../entities/types").Order } order */
function getTaxOnCommissionBrand(order) {
  return getTVAFromAmountWithTax(getCommissionBrand(order), order.country);
}

/** @param { import("../entities/types").Order } order */
function getTaxOnCommissionCustomer(order) {
  if (order.process === 'RETAIL') return getTVAFromAmountWithTax(getTotalForCustomer(order), order.country);
  return getTVAFromAmountWithTax(getCommissionCustomer(order), order.country);
}

/** @param { import("../entities/types").Order } order */
function getTotalPaidBrandWithTax(order) {
  var tvaRatio = (0, _tvaRatios.getTvaRatioByCountry)(order.country);
  var taxFactor = 1 + tvaRatio;
  if (order.doesBrandPayRounded) {
    var baseWithoutTax = getTotalBrandRevenue(order);
    var revenueWithTax = (0, _orderPriceUtils.round)(taxFactor * baseWithoutTax);
    var cashCollection = getTotalCashCollection(order);
    return (0, _orderPriceUtils.round)(revenueWithTax + cashCollection);
  }
  if (order.doesBrandPayTVAonAll) {
    var commissionRatio = getCommissionRatio(order);
    var taxOnCommission = getTVAFromAmountWithTax((0, _orderPriceUtils.round)(getTotalPaidBrand(order, true) * commissionRatio), order.country);
    var _cashCollection = getTotalCashCollection(order);
    var _baseWithoutTax = Math.max(getTotalPaidBrand(order) - taxOnCommission - _cashCollection, 0);
    var baseWithTax = (0, _orderPriceUtils.round)(taxFactor * _baseWithoutTax);
    return (0, _orderPriceUtils.round)(baseWithTax + _cashCollection);
  }
  return getTotalPaidBrand(order);
}

/** @param { import("../entities/types").Order } order */
function getTotalWithoutTax(order) {
  var taxOnCommission = getTaxOnCommission(order);
  return getTotalForCustomer(order) - taxOnCommission;
}

/** @param { import("../entities/types").Order } order */
function getTaxCustomer(order) {
  return getTaxOnCommissionCustomer(order);
}

/** @param { import("../entities/types").Order } order */
function getTaxBrand(order) {
  var taxOnCommissionBrand = getTaxOnCommissionBrand(order);
  var tvaRatio = (0, _tvaRatios.getTvaRatioByCountry)(order.country);
  if (order.doesBrandPayRounded) {
    var baseWithoutTax = getTotalPaidBrand(order);
    return (0, _orderPriceUtils.round)(tvaRatio * baseWithoutTax);
  }
  if (order.doesBrandPayTVAonAll) {
    var _baseWithoutTax2 = getTotalPaidBrand(order) - taxOnCommissionBrand;
    return (0, _orderPriceUtils.round)(tvaRatio * _baseWithoutTax2);
  }
  return taxOnCommissionBrand;
}

/** @param { import("../entities/types").Order } order */
function getTax(order) {
  return (0, _orderPriceUtils.round)(getTaxCustomer(order) + getTaxBrand(order));
}

/** @param { import("../entities/types").Order } order */
function getTaxOpaqueCouturier(order) {
  return (0, _orderPriceUtils.round)(getTax(order) - getTaxOnCommission(order));
}

/** @param { import("../entities/types").Order } order */
function getTotalWithTax(order) {
  var tax = getTax(order);
  return (0, _orderPriceUtils.round)(getTotalWithoutTax(order) + tax);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getThresholdGuarantee(order) {
  var commissionRatio = getCommissionRatio(order);
  var minTotalCouturier = getMinTotalCouturier(order);
  if (commissionRatio === 1) return 0;
  return minTotalCouturier / (1 - commissionRatio);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getTotalGuarantee(order) {
  var totalBase = getTotalForCustomer(order) - getDeliveryFees(order) - getMinOrderAmountFee(order);
  return Math.max(getThresholdGuarantee(order) - totalBase, 0);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getTotalGuaranteeArtisan(order) {
  return getTotalGuarantee(order) * (1 - getCommissionRatio(order));
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getTotalGuaranteeTilli(order) {
  return getTotalGuarantee(order) * getCommissionRatio(order);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getTotal(order) {
  return getTotalForCustomer(order);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getTotalWithGuarantee(order) {
  return getTotalForCustomer(order) + getTotalGuarantee(order) - getMinOrderAmountFee(order);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getVolumeAffaires(order) {
  var _order$discounts4;
  var orderWithoutBrandPayingDiscounts = _objectSpread(_objectSpread({}, order), {}, {
    discounts: (_order$discounts4 = order.discounts) === null || _order$discounts4 === void 0 ? void 0 : _order$discounts4.filter(function (discount) {
      var brandPromoCodes = getBrandPromoCodes(order, {
        includesNonPaying: true
      });
      return brandPromoCodes.includes(discount) && !discount.doesBrandNotPay;
    })
  });
  return getTotalWithGuarantee(orderWithoutBrandPayingDiscounts) - getTotalPaidBrand(orderWithoutBrandPayingDiscounts) + getTotalPaidBrandWithTax(orderWithoutBrandPayingDiscounts);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getChiffreAffaires(order) {
  var _order$discounts5;
  var orderWithoutExcludedDiscounts = _objectSpread(_objectSpread({}, order), {}, {
    discounts: (_order$discounts5 = order.discounts) === null || _order$discounts5 === void 0 ? void 0 : _order$discounts5.filter(function (discount) {
      return discount.reason !== 'REPAIR_BONUS' && discount.reason !== 'GIFT_CARD';
    })
  });
  return getCommissionBrandWithTax(orderWithoutExcludedDiscounts) + getCommissionCustomer(orderWithoutExcludedDiscounts) + getTotalGuaranteeTilli(order);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getChiffreAffairesBrut(order) {
  var _order$discounts6;
  var orderWithoutExcludedDiscounts = _objectSpread(_objectSpread({}, order), {}, {
    discounts: (_order$discounts6 = order.discounts) === null || _order$discounts6 === void 0 ? void 0 : _order$discounts6.filter(function (discount) {
      var brandPromoCodes = getBrandPromoCodes(order, {
        includesNonPaying: true
      });
      return brandPromoCodes.includes(discount) && !discount.doesBrandNotPay && discount.type !== 'FOR_BRAND';
    })
  });
  return getCommissionBrandWithTax(orderWithoutExcludedDiscounts) + getCommissionCustomer(orderWithoutExcludedDiscounts) + getTotalGuaranteeTilli(order);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getMarginGross(order) {
  var _order$process;
  if ((_order$process = order.process) !== null && _order$process !== void 0 && _order$process.includes('PACKAGE')) {
    return getChiffreAffairesBrut(order) - order.deliveryFee;
  }
  return getChiffreAffairesBrut(order);
}

/**
 * @param { import("../entities/types").Order } order
 * @returns {number}
 */
function getMarginNet(order) {
  var _order$process2;
  if ((_order$process2 = order.process) !== null && _order$process2 !== void 0 && _order$process2.includes('PACKAGE')) {
    return getChiffreAffaires(order) - order.deliveryFee;
  }
  return getChiffreAffaires(order);
}